import { render } from "./DropdownFilters.vue?vue&type=template&id=355a6a31&scoped=true&ts=true"
import script from "./DropdownFilters.vue?vue&type=script&lang=ts"
export * from "./DropdownFilters.vue?vue&type=script&lang=ts"

import "./DropdownFilters.vue?vue&type=style&index=0&id=355a6a31&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355a6a31"]])

export default __exports__